import { render, staticRenderFns } from "./expertises.vue?vue&type=template&id=683597be"
import script from "./expertises.vue?vue&type=script&lang=js"
export * from "./expertises.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports